<template>
  <v-card class="ml-5 mt-3 pa-2 font-weight-light">
    <v-tabs fixed-tabs background-color="primary" dark>
      <v-tabs-slider height="4px" color="black"></v-tabs-slider>
      <v-tab class="font-weight-light">{{getTranslation('Detail report','mapFilters')}}</v-tab>
      <v-tab class="font-weight-light">{{getTranslation('Travel history','mapFilters')}}</v-tab>
      <v-tab class="font-weight-light">{{getTranslation('Stoppages','mapFilters')}}</v-tab>
      <v-tab v-if="routes.statistics" class="font-weight-light">{{getTranslation('Statistics','mapFilters')}}</v-tab>
      <v-tab-item class="">
        <v-btn
          color="success"
          x-small
          class="font-weight-light mt-3 mb-3"
          @click="goToStart"
        >{{labels.startPoint}}</v-btn>
        <v-btn
          color="primary"
          x-small
          class="ml-2 font-weight-light"
          @click="goToEnd"
        >{{labels.endPoint}}</v-btn>
        <!--added height -->
        <div md6 class="local-table">
          <!--added overflow-->
          <v-data-table
            dense
            single-select
            height="28vh"
            :fixed-header="true"
            v-model="selected"
            :headers="detailsHeaders"
            :items="routes.allDetails"
            :item-class="tableRowClass"
            item-key="timestamp"
            @click:row="rowClick"
            disable-pagination
            hide-default-footer
            width="100%"
            class="text-caption"
            :custom-sort="customSort"
          >
            <template v-slot:item.timestamp="{ item }">{{ item.timestamp | datetime}}</template>
          </v-data-table>
          <v-row class="pl-8 pt-1">
              <v-btn color="success" small @click='exportAsCsv(routes.allDetails)' class="mr-2 font-weight-light">CSV</v-btn>
              <v-btn color="success" small @click='exportAsExcel(routes.allDetails,detailsHeaders)' class="mr-2 font-weight-light">Excel</v-btn>
              <v-btn color="success" small @click="exportAsPdf(routes.allDetails,detailsHeaders)" class="mr-2 font-weight-light">PDF</v-btn>
              <v-btn color="success" small @click="exportAsGpx(routes.gpx)" class="mr-2 font-weight-light">GPX</v-btn>
          </v-row>
        </div>
      </v-tab-item>

      <v-tab-item class="local-table">
        <v-data-table
          dense
          height="31vh"
          :fixed-header="true"
          :headers="movementHistoryHeaders"
          :items="routes.movementHistory"
          :item-class="rowGreen"
          item-key="timestamp"
          :single-select="singleSelect"
          disable-pagination
          hide-default-footer
          width="100%"
          class="text-caption mt-3"
          :custom-sort="customSort"
        >
          <template v-slot:item.search="{ item }">
            <v-icon color="primary" @click="onSearchRouteEvent(item)">search</v-icon>
          </template>
          <template v-slot:item.startedDrivingAt="{ item }">{{ item.startedDrivingAt | datetime}}</template>
          <template v-slot:item.stoppedAt="{ item }">{{ item.stoppedAt | datetime}}</template>
        </v-data-table>
        <v-row class="pl-8 pt-1">
              <v-btn color="success" small @click='exportAsCsv(routes.movementHistory)' class="mr-2 font-weight-light">CSV</v-btn>
              <v-btn color="success" small @click='exportAsExcel(routes.movementHistory,movementHistoryHeaders)' class="mr-2 font-weight-light">Excel</v-btn>
              <v-btn color="success" small @click="exportAsPdf(routes.movementHistory,movementHistoryHeaders)" class="mr-2 font-weight-light">PDF</v-btn>
        </v-row>
      </v-tab-item>
      <v-tab-item class="local-table"> 
        <v-chip color="#b2ebf2" small class="ml-2 mt-2">Pod kontaktom</v-chip>
        <v-chip color="#ffab91" small class="ml-2 mt-2">Bez kontakta</v-chip>
        <v-data-table
          height="29vh"
          dense
          :headers="stopsHeaders"
          :items="routes.stops"
          :item-class="tableRowClass"
          item-key="timestamp"
          :single-select="singleSelect"
          disable-pagination
          hide-default-footer
          width="100%"
          class="text-caption mt-2"
          :custom-sort="customSort"
        >
          <template v-slot:item.timestamp="{ item }">{{ item.timestamp | datetime}}</template>
        </v-data-table>
        <v-row class="pl-8 pt-1">
            <v-btn color="success" small @click="exportAsCsv(routes.stops)" class="mr-2 font-weight-light">CSV</v-btn>
            <v-btn color="success" small @click="exportAsExcel(routes.stops,stopsHeaders)" class="mr-2 font-weight-light">Excel</v-btn>
            <v-btn color="success" small @click="exportAsPdf(routes.stops,stopsHeaders)" class="mr-2 font-weight-light">PDF</v-btn>
        </v-row>
      </v-tab-item>
      <v-tab-item v-if="routes.statistics" class="text-center local-table">
        <v-simple-table dense class="stripped font-weight-light mt-3">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">{{labels.statistic}}</th>
                <th class="text-left">{{labels.value}}</th>
                <th class="text-left">{{labels.date}}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-left">{{labels.averageSpeed}}</td>
                <td class="text-left">{{ routes.statistics.averageSpeed }} km/h</td>
                <td class="text-left"></td>
              </tr>
              <tr>
                <td class="text-left">{{labels.distance}}</td>
                <td class="text-left">{{ Math.round(routes.statistics.distance, 2) }} km</td>
                <td class="text-left"></td>
              </tr>
              <tr v-if="routeOptimizationData && Object.keys(routeOptimizationData).length != 0">
                <td class="text-left">{{labels.optimizedDistance}}</td>
                <td class="text-left">{{ routeOptimizationData.totalDistance }} km</td>
                <td class="text-left"></td>
              </tr>
              <tr>
                <td class="text-left">{{labels.vehicleInMottion}}</td>
                <td class="text-left">{{ routes.statistics.engineOnMovingSpan }}</td>
                <td class="text-left"></td>
              </tr>
              <tr>
                <td class="text-left">{{labels.vehicleStanding}}</td>
                <td class="text-left">{{ routes.statistics.engineOnStoppedSpan }}</td>
                <td class="text-left"></td>
              </tr>
              <tr>
                <td class="text-left">{{labels.vehicleOff}}</td>
                <td class="text-left">{{ routes.statistics.engineOffSpan }}</td>
                <td class="text-left"></td>
              </tr>
              <tr>
                <td class="text-left">{{labels.maxSpeed}}</td>
                <td class="text-left">{{ routes.statistics.maxSpeedInfo.maxSpeed }} km/h</td>
                <td class="text-left">
                  <a
                    class="nav-link"
                    @click="onMaxSpeedClick"
                  >{{convertDate(routes.statistics.maxSpeedInfo.timestamp)}}</a>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-row class="pl-8 pt-1">
            <v-btn color="success" small @click="exportAsCsv([[labels.averageSpeed,routes.statistics.averageSpeed,''],[labels.distance, Math.round(routes.statistics.distance, 2),''],[labels.vehicleInMottion,routes.statistics.engineOnMovingSpan,''],[labels.vehicleStanding,routes.statistics.engineOnStoppedSpan,''],[labels.vehicleOff,routes.statistics.engineOffSpan,''],[labels.maxSpeed,routes.statistics.maxSpeedInfo.maxSpeed,convertDate(routes.statistics.maxSpeedInfo.timestamp)]])" class="mr-2 font-weight-light">CSV</v-btn>
            <v-btn color="success" small @click="exportAsExcel([[labels.averageSpeed,routes.statistics.averageSpeed,''],[labels.distance,Math. round(routes.statistics.distance, 2),''],[labels.vehicleInMottion,routes.statistics.engineOnMovingSpan,''],[labels.vehicleStanding,routes.statistics.engineOnStoppedSpan,''],[labels.vehicleOff,routes.statistics.engineOffSpan,''],[labels.maxSpeed,routes.statistics.maxSpeedInfo.maxSpeed,convertDate(routes.statistics.maxSpeedInfo.timestamp)]],[{text:labels.statistic},{text:labels.value},{text:labels.date}])" class="mr-2 font-weight-light">Excel</v-btn>
            <v-btn color="success" small @click="exportAsPdf([[labels.averageSpeed,routes.statistics.averageSpeed,''],[labels.distance, Math.round(routes.statistics.distance, 2),''],[labels.vehicleInMottion,routes.statistics.engineOnMovingSpan,''],[labels.vehicleStanding,routes.statistics.engineOnStoppedSpan,''],[labels.vehicleOff,routes.statistics.engineOffSpan,''],[labels.maxSpeed,routes.statistics.maxSpeedInfo.maxSpeed,convertDate(routes.statistics.maxSpeedInfo.timestamp)]],[{text:labels.statistic},{text:labels.value},{text:labels.date}])" class="mr-2 font-weight-light">PDF</v-btn>
        </v-row>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
import EventBus from '../../../event-bus'
import httpClient from '@/api/httpClient'
import translate from '@/utils/genTable/multilanguageHelper.js'
import formatDate from '@/utils/formatDateHelper.js'
import store from '@/store/store'
import { mapState } from 'vuex'
import dataTableSort from '@/utils/dataTableSort.js'
import Papa from 'papaparse'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
const Excel = require('exceljs')
import { globalConstants } from '@/utils/globalConstants'
import vkbeautify from 'vkbeautify'; 

export default {
  props: {
    routes: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      statistics: [],
      detailsHeaders: [
        {
          text: translate('Vehicle Label', 'realtimeMap'),
          value: 'vehicleLabel'
        },
        { text: translate('Driver Name', 'realtimeMap'), value: 'driverName' },
        { text: translate('Time', 'realtimeMap'), value: 'timestamp' },
        { text: translate('Speed', 'realtimeMap'), value: 'speed' }
      ],
      movementHistoryHeaders: [
        { text: translate('Search', 'realtimeMap'), value: 'search' },
        {
          text: translate('Vehicle Label', 'realtimeMap'),
          value: 'vehicleLabel'
        },
        { text: translate('Driver Name', 'realtimeMap'), value: 'driverName' },
        {
          text: translate('Start time', 'realtimeMap'),
          value: 'startedDrivingAt'
        },
        {
          text: translate('Mileage on start', 'realtimeMap'),
          value: 'mileageOnDeparture'
        },
        {
          text: translate('Start Point', 'realtimeMap'),
          value: 'startAddress'
        },
        { text: translate('End time', 'realtimeMap'), value: 'stoppedAt' },
        {
          text: translate('Mileage on end', 'realtimeMap'),
          value: 'mileageOnArrival'
        },
        { text: translate('End point', 'realtimeMap'), value: 'stopAddress' },
        {
          text: translate('Covered distance', 'realtimeMap'),
          value: 'distance'
        },
        { text: translate('Duration', 'realtimeMap'), value: 'span' }
      ],
      stopsHeaders: [
        { text: translate('Number of stoppage', 'realtimeMap'), value: 'id' },
        {
          text: translate('Vehicle Label', 'realtimeMap'),
          value: 'vehicleLabel'
        },
        { text: translate('Driver Name', 'realtimeMap'), value: 'driverName' },
        { text: translate('Time', 'realtimeMap'), value: 'timestamp' },
        {
          text: translate('Stop duration', 'realtimeMap'),
          value: 'stopDuration'
        },
        { text: translate('Address', 'realtimeMap'), value: 'address' }
      ],
      dateColumns: [
        'stoppedAt',
        'startedDrivingAt',
        'timestamp'
      ],
      headersToIgnore: [
        'longitude',
        'latitude',
        'color',
        'isVehicleTurnedOn',
        'startLat',
        'startLong',
        'stopLat',
        'stopLong',
        'ioEventName'
      ],
      selected: [],
      singleSelect: false,
      labels: {
        startPoint: translate('Start Point', 'realtimeMap'),
        endPoint: translate('End point', 'realtimeMap'),
        distance: translate('Distance', 'realtimeMap'),
        optimizedDistance: translate('Optimized route', 'realtimeMap'),
        maxSpeed: translate('Max speed', 'realtimeMap'),
        statistic: translate('Statistic', 'realtimeMap'),
        date: translate('Date', 'realtimeMap'),
        value: translate('Value', 'realtimeMap'),
        averageSpeed: translate('Average speed', 'realtimeMap'),
        vehicleInMottion: translate(
          'Total engine running time while the vehicle is in motion',
          'realtimeMap'
        ),
        vehicleStanding: translate(
          'Total engine running time while the vehicle is stationary',
          'realtimeMap'
        ),
        vehicleOff: translate('Total time the engine is off', 'realtimeMap')
      },
      sorts: {
        timestamp: 'date',
        startedDrivingAt: 'date',
        stoppedAt: 'date',
        span: 'timespan',
        stopDuration: 'timespan',
        speed: 'numeric',
        latitude: 'numeric',
        longitude: 'numeric',
        distance: 'numeric',
        mileageOnArrival: 'numeric',
        mileageOnDeparture: 'numeric',
        averageSpeed: 'numeric'
      }
    }
  },
  watch: {
    selected: {
      handler() {
        EventBus.$emit('ROUTE_HISTORY_SHOW_SELECTED_ROW_POSITION_ON_MAP', {
          markers: this.selected
        })
      }
    },
    routes: {
      handler() {
        this.populateAddresses()
      }
    }
  },
  async mounted() {
    dataTableSort.setSorts(this.sorts)
    this.populateAddresses()
    var that = this
    window.addEventListener('keyup', e => {
      if (!that.selected[0]) {
        return
      }
      let currentTimestamp = that.selected[0].timestamp
      let nextItem = null

      if (e.key == 'ArrowDown') {
        nextItem = that.routes.details.filter(
          x => x.timestamp > currentTimestamp
        )[0]
      }

      if (e.key == 'ArrowUp') {
        for (let i = that.routes.details.length - 1; i > 0; i--) {
          if (that.routes.details[i].timestamp < currentTimestamp) {
            nextItem = that.routes.details[i]
            break
          }
        }
      }

      if (!nextItem) {
        return
      }

      that.selected = []
      that.selected.push(nextItem)
    })
    await httpClient.get('/pois/GetCount').then(result => {
      if(result.data.totalRecords < globalConstants.poisLimit) {
        this.movementHistoryHeaders.push({ text: 'Poi', value: 'poiName' })
      } else {
        this.headersToIgnore.push('poiName')
      }
    })
  },
  computed: {
    ...mapState('history', [
      'routeOptimizationData'
    ]),
    customSort: () => dataTableSort.sort
  },
  methods: {
    onSearchRouteEvent(item) {
      const points = {
        startPoint: {
          latitude: item.startLat,
          longitude: item.startLong,
          time: item.startedDrivingAt
        },
        stopPoint: {
          latitude: item.stopLat,
          longitude: item.stopLong,
          time: item.stoppedAt
        }
      }
      const markers = []
      markers[0] = { latitude: item.startLat, longitude: item.startLong }
      markers[1] = { latitude: item.stopLat, longitude: item.stopLong }
      store.dispatch('history/displayRouteSegment', {
        route: points,
        markers: markers
      })
    },
    rowClick(item, row) {
      row.select(true)
      this.selected = []
      this.selected.push(item)
    },
    onMaxSpeedClick() {
      const maxSpeedTime = Date.parse(
        this.routes.statistics.maxSpeedInfo.timestamp
      )
      const point = this.routes.details.filter(route => {
        return Date.parse(route.timestamp) == maxSpeedTime
      })
      this.selected = []
      this.selected.push(point[0])
    },
    tableRowClass(item) {
      if (!item.isVehicleTurnedOn) {
        return 'row-red'
      } else {
        if (!item.speed) {
          return 'row-blue'
        } else {
          return 'row-green'
        }
      }
    },
    rowGreen(item) {
      return 'row-green'
    },
    rowRed(item) {
      return 'row-red'
    },
    goToStart() {
      EventBus.$emit('ROUTE_HISTORY_GO_TO_START')
    },
    goToEnd() {
      EventBus.$emit('ROUTE_HISTORY_GO_TO_END')
    },
    getPropertyData(dataProperty) {
      let data = this
      var allFields = dataProperty.split('.')
      allFields.forEach(element => {
        data = data[element]
      })
      return data
    },
    async populateAddresses() {
      let coordinates = []
      this.routes.movementHistory.forEach(x => {
        let startLocation = this.routes.details.filter(
          y => y.timestamp == x.startedDrivingAt
        )[0]
        let stopLocation = this.routes.details.filter(
          y => y.timestamp == x.stoppedAt
        )[0]

        x.startLat = startLocation.latitude
        x.startLong = startLocation.longitude

        x.stopLat = stopLocation.latitude
        x.stopLong = stopLocation.longitude

        coordinates.push({
          latitude: startLocation.latitude,
          longitude: startLocation.longitude
        })

        coordinates.push({
          latitude: stopLocation.latitude,
          longitude: stopLocation.longitude
        })
      })

      let movementHistoryResponse = await httpClient.post(
        'lookup/locations',
        coordinates
      )
      this.routes.movementHistory.forEach(m => {
        let startLocation = movementHistoryResponse.data.filter(
          x => x.latitude == m.startLat && x.longitude == m.startLong
        )[0]
        m.startAddress = startLocation.address

        let stopLocation = movementHistoryResponse.data.filter(
          x => x.latitude == m.stopLat && x.longitude == m.stopLong
        )[0]
        m.stopAddress = stopLocation.address
      })

      coordinates = []
      this.routes.stops.forEach(x => {
        coordinates.push({
          latitude: x.latitude,
          longitude: x.longitude
        })
      })

      let stopsTmp = []
      let stopsResponse = await httpClient.post('lookup/locations', coordinates)

      this.routes.stops.forEach(x => {
        x.id = x.id + 1
        x.address = stopsResponse.data.filter(
          r => r.latitude == x.latitude && r.longitude == x.longitude
        )[0].address
        stopsTmp.push(x)
      })
      this.routes.stops = []
      this.routes.stops = stopsTmp
    },
    convertDate(date) {
      return formatDate(date, 'long', true)
    },
    getTranslation(text, location) {
      return translate(text, location)
    },
    prepareDataForExport(dataProperty) {
      let data = this.getPropertyData(dataProperty)
      let preparedData = []
      let tempObject = {}
      data.forEach(x => {
        tempObject = {}
        for (var prop in x) {
          var foundHeader = data.find(h => {
            return h.value == prop
          })
          if (foundHeader) {
            var translatedProp = foundHeader.text
            tempObject[translatedProp] = x[prop]
          }
        }
        preparedData.push(tempObject)
      })

      return preparedData
    },
    exportAsCsv(preparedData) {
      var blob = new Blob(['\ufeff', Papa.unparse(this.prepareDataForCsv(preparedData))], {
        type: 'text/csv;charset=utf-8;'
      })

      var link = document.createElement('a')

      var url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute(
        'download',
        `Report-${Math.floor(Date.now() / 1000)}.csv`
      )
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    prepareDataForCsv(data) {
      let preparedData = JSON.parse(JSON.stringify(data))     

      if (preparedData.length)
      {
        let keys = Object.keys(preparedData[0])
        
        for (let x of preparedData) {
          for (let key of keys) {
            if (this.dateColumns.includes(key)) {
              x[key] = this.convertDate(x[key])
            }
          }
        }
      }

      return preparedData
    },
    prepareHeadersForExcel(headers) {
      let preparedHeaders = []

      headers.forEach(header => {
        if ((header.value && header.value != 'search') || !header.value) {
          preparedHeaders.push({
            name: header.text,
            filterButton: false
          })
        }
      })

      return preparedHeaders
    },
    prepareDataForExcel(preparedData) {
      let data = []
      preparedData.forEach(x => {
        let keys = Object.keys(x)
        let tempArray = []
        for (let key of keys) {
          if (key == 'formated') {
            continue
          }
          if (this.headersToIgnore.includes(key)) {
            continue
          }
          if (this.dateColumns.includes(key)){
            tempArray.push(this.convertDate(x[key]))
            continue
          }
          if (x[key] == null) {
            x[key] = ''
          }
          tempArray.push(x[key])
        }
        data.push(tempArray)
      })

      data.forEach(x => {
        x.forEach(val => {
          if (typeof val == 'object') {
            let index = x.indexOf(val)
            if (index > -1) {
              x.splice(index, 1)
            }
          }
        })
      })

      return data
    },
    exportAsExcel(dataProperty, headersProperty) {
      const workbook = new Excel.Workbook()
      workbook.creator = 'Puregreen'
      workbook.lastModifiedBy = 'Puregreen'

      const ws = workbook.addWorksheet('Route History')

      const headers = this.prepareHeadersForExcel(headersProperty)
      const data = this.prepareDataForExcel(dataProperty)
      ws.mergeCells('A1:E1')
      ws.getCell('A1').value = `${'Route History'}`

      ws.addTable({
        name: 'MyTable',
        ref: 'A3',
        headerRow: true,
        totalsRow: false,
        style: {
          theme: 'TableStyleLight20',
          showRowStripes: true
        },
        columns: headers,
        rows: data
      })

      const cellsToSkip = ['A1', 'B1', 'C1', 'D1', 'E1']

      ws.columns.forEach(column => {
        var dataMax = 0
        column.eachCell({ includeEmpty: true }, function(cell) {
          if (!cellsToSkip.includes(cell.address)) {
            var columnLength = cell.value ? cell.value.length : 0
            if (columnLength > dataMax) {
              dataMax = columnLength
            }
          }
        })
        column.width = dataMax < 10 ? 10 : dataMax + 5
      })

      workbook.xlsx.writeBuffer().then(function(data) {
        const blob = new Blob([data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const url = window.URL.createObjectURL(blob)
        const anchor = document.createElement('a')
        anchor.href = url
        anchor.download = `Report-${Math.floor(Date.now() / 1000)}.xlsx`
        anchor.click()
        window.URL.revokeObjectURL(url)
      })
    },
    exportAsPdf(sourceData, preparedHeadersData) {
      let headers = []
      let rows = []
      let pdfName = `Report-${Math.floor(Date.now() / 1000)}`

      preparedHeadersData.forEach(header => {
        if (header.value != 'search'){
          headers.push({
            content: header.text,
            styles: { minCellWidth: 15, fontSize: 6 }
          })
        }
      })

      headers.forEach(h => {
        h.content = h.content.replace('č', 'c')
        h.content = h.content.replace('Č', 'č')
        h.content = h.content.replace('đ', 'dj')
        h.content = h.content.replace('Đ', 'Dj')
      })

      sourceData.forEach(element => {
        var temp = []
        for (var prop in element) {
          temp.push({
            content: element[prop] == null ? '' : this.dateColumns.includes(prop) ? this.convertDate(element[prop]) : element[prop],
            styles: { minCellWidth: 15, fontSize: 6 }
          })
        }

        rows.push(temp)
      })
      var doc = new jsPDF('landscape')
      doc.autoTable({
        head: [headers],
        body: rows,
        startY: 10
      })
      doc.save(pdfName + '.pdf')
    },
    exportAsGpx(xmlDocAsString) {
      let blob = new Blob([vkbeautify.xml(xmlDocAsString)], { type: "text/xml" })
      let url = URL.createObjectURL(blob)

      let link = document.createElement("a")
      link.setAttribute('href', url)
      link.setAttribute(
        'download',
        `Report-${Math.floor(Date.now() / 1000)}.gpx`
      )
      
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>

<style src="../../../assets/table_row.css">
</style>

<style>
.v-tab {
  font-size: 13px;
}
.black {
  background: black;
}
</style>
